module.exports = __webpack_public_path__ + "static/screen_8-68a718aae087b8f7593544b9110176f5.png";